import { getParams } from "../../../../../../../../../src/modules/wizards/services";

export default {
    wizardType: "MARIADBXPAND",

    getJDBCURL: (m) => "jdbc:mariadb://" + m.get("host") + ":" + m.get("port"),

    getConnectionParams: async (type, model) => getParams(type, model),
};

